import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { KeyboardService } from '../../keyboard/keyboard.service';

@Component({
  selector: 'app-input-text-area',
  templateUrl: './input-text-area.component.html',
  styleUrls: ['./input-text-area.component.sass'],
})
export class InputTextAreaComponent implements OnInit {
  @Input()
  config: IFieldConfig;
  @Input()
  group: FormGroup;
  @Input()
  typeCes?: TypeCesEnum | undefined;
  keyboardChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(public keyboardService: KeyboardService) {}

  ngOnInit(): void {
    this.keyboardChange.subscribe((event) => {
      this.group.get(this.config.name)?.setValue(event);
    });
  }
}
